import {debounce} from "../utils/debounce";

window.addEventListener('load', () => {
    const form = document.querySelector("form.aanbod-archive-filter-form");
    if (!form) return;

    // to add a new filter item to the url just enter the name of the form field here
    const form_keys = [
        'locatie',
        'status'
    ];

    function on_form_change() {
        const formData = new FormData(form as HTMLFormElement);
        const url = new URL(window.location.href);

        for (const key of form_keys) {
            const val = formData.get(key) || null;
            if (!val) {
                url.searchParams.delete(key);
            } else {
                url.searchParams.set(key, val.toString());
            }
        }

        window.location.href = url.toString();
    }

    const debounceChange = debounce(on_form_change, 500);
    form.addEventListener("change", debounceChange);
});
